// Lib
import React from 'react';

/**
 * This is used to allow POIs to know what section they belong to.
 * Their section cannot be simply passed down as a prop due to some POIs existing within Draft JS, which
 * will not pass the parent props in.
 */
const PoiBoardSectionContext = React.createContext(null);
export default PoiBoardSectionContext;

export const poiBoardSectionContextConsumer = (DecoratedComponent) => {
    class PoiBoardSectionContextConsumer extends React.Component {
        render() {
            return <DecoratedComponent boardSection={this.context} {...this.props} />;
        }
    }

    PoiBoardSectionContextConsumer.contextType = PoiBoardSectionContext;

    return PoiBoardSectionContextConsumer;
};
